import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import trialVideo1 from "../../assets/images/resources/trial_welcome_1.mp4";
import trialVideo2 from "../../assets/images/resources/trial_welcome_2.mp4";
import trialVideo3 from "../../assets/images/resources/trial_welcome_3.mp4";
import trialThumb1 from "../../assets/images/resources/trial_welcome_1.png";
import trialThumb2 from "../../assets/images/resources/trial_welcome_2.png";
import trialThumb3 from "../../assets/images/resources/trial_welcome_3.png";

const videos = [
  { src: trialVideo1, title: "How to Use the Free Trial", thumbnail: trialThumb1 },
  { src: trialVideo2, title: "Buyer's Club Walkthrough", thumbnail: trialThumb2 },
  { src: trialVideo3, title: "Product Search and Selection", thumbnail: trialThumb3 },
];

const bookingScriptSrc = "https://link.msgsndr.com/js/form_embed.js";

const TrialWelcome = () => {
  document.title = "How to use the free trial | Buyers Club";
  const navigate = useNavigate();
  const [playingIdx, setPlayingIdx] = useState(null);
  const videoRefs = useRef([]);

  useEffect(() => {
    let script = document.querySelector(`script[src="${bookingScriptSrc}"]`);
    let shouldRemoveScript = false;

    if (!script) {
      script = document.createElement("script");
      script.src = bookingScriptSrc;
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
      shouldRemoveScript = true;
    }

    return () => {
      if (shouldRemoveScript && script?.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  const renderVideoCard = (video, idx) => (
    <Card className="mb-4 shadow-sm" key={idx}>
      <CardBody className="p-4 d-flex flex-column">
        <h5 className="fw-semibold mb-3">{video.title}</h5>
        <div className="ratio ratio-16x9">
          {playingIdx === idx ? (
            <video
              ref={(el) => (videoRefs.current[idx] = el)}
              controls
              className="rounded"
            >
              <source src={video.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center bg-light rounded"
              style={{
                cursor: "pointer",
                ...(video.thumbnail
                  ? {
                      backgroundImage: `url(${video.thumbnail})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }
                  : {}),
              }}
              onClick={() => {
                setPlayingIdx(idx);
                setTimeout(() => {
                  if (videoRefs.current[idx]) videoRefs.current[idx].play();
                }, 0);
              }}
            >
              <div
                className="text-center"
                style={{ textShadow: "0 2px 8px rgba(0, 0, 0, 0.35)" }}
              >
                <i className="ri-play-circle-fill text-primary" style={{ fontSize: 72 }}></i>
                <p className="text-white mt-2 mb-0 fw-semibold">Click to play video</p>
              </div>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="How to use the free trial" pageTitle="Welcome" />

        <Row>
          <Col xs={12}>
            {/* Hero section */}
            <div className="text-center mb-5">
              <h1 className="fw-bold">Welcome to Your Free Trial!</h1>
              <p className="text-muted fs-16 mt-2">
                You have full access to the Buyers Club catalog and features.
                Watch the video below to learn how to make the most of it.
              </p>
            </div>

            <Row>
              <Col xs={12} lg={6}>
              {renderVideoCard(videos[0], 0)}
              <div className="d-none d-lg-block">
                {renderVideoCard(videos[1], 1)}
                {renderVideoCard(videos[2], 2)}
              </div>
              </Col>
              <Col xs={12} lg={6}>
              <Card className="mb-4 shadow-sm h-100">
                <CardBody className="p-4">
                <h5 className="fw-semibold mb-3">Book a Call</h5>
                <iframe
                  src="https://api.leadconnectorhq.com/widget/booking/T8uhkdrIHr8td79Xt4iz"
                  title="Book a Call"
                  style={{ width: "100%", border: "none", overflow: "hidden", minHeight: "680px" }}
                  scrolling="no"
                  id="T8uhkdrIHr8td79Xt4iz_1778872020655"
                ></iframe>
                </CardBody>
              </Card>
              </Col>
              <Col xs={12} className="d-lg-none">
              {renderVideoCard(videos[1], 1)}
              {renderVideoCard(videos[2], 2)}
              </Col>
            </Row>

            {/* CTA */}
            <div className="text-center mt-3 mt-lg-4 mb-4">
              <Button
                color="success"
                size="lg"
                className="px-5"
                onClick={() => navigate("/products")}
              >
                <i className="ri-arrow-right-line me-2"></i>
                Go to the Product Catalog
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TrialWelcome;
